import {cookies} from "angular";

angular.module('logbook')
  .config(['$httpProvider', function($httpProvider) {

    $httpProvider.lastUpdateWarning = null;
    
    $httpProvider.useApplyAsync(true);
    
    $httpProvider.checkForUserMismatch = function($rootScope, $window, response)
    {
       var userId = response.headers('X-Logbook-User-Id');
       if( userId 
           && $rootScope.lastSeenUserId 
           && userId != $rootScope.lastSeenUserId )
       {
          console.log('user mismatch');
          $rootScope.$emit('$routeChangeError');
          $window.location.href='/#/logs';
          $window.location.reload();
          delete $rootScope.lastSeenUserId;
          return true;
       }
       else if( userId )
          $rootScope.lastSeenUserId = userId;
       
       return false;
    };

    $httpProvider.defaults.transformResponse.splice(0, 0,
      function(data, headersGetter) {
        if (data && headersGetter()['content-type'] != undefined && headersGetter()['content-type'].indexOf('application/json') >= 0) {
          return JSOG.parse(data);
        } else {
          return data;
        }
      });
    
    $httpProvider.cleanHrefs = function(object) {
       if( !object || typeof(object) != 'object')
          return;
       Object.keys(object).forEach(function(key) {
          if( key == 'href')
             object[key] = object[key].replace(/\{.*\}/,'');
          if( typeof(object[key]) == 'object' )
             $httpProvider.cleanHrefs(object[key]);
          if( Array.isArray(object[key]))
             object[key].forEach(function(obj) {
                $httpProvider.cleanHrefs(obj);
             });
       });
       
	  };
	  
    $httpProvider.interceptors.push([
		'$q', '$rootScope', '$injector', '$timeout', '$window', 'logoutService', 'logBookService', 'primeNGHelpersService', 'appStateService',
		function($q, $rootScope, $injector, $timeout, $window, logoutService, logBookService, primeNGHelpersService, appStateService) {

            function showErrorDialog() {
                const cookieService = $injector.get('cookieService');
                return cookieService.get('suppress-error-toast') === 'true';
            }

      return {
        'request': function(config) {
          if( !$rootScope.activeHttpRequests )
             $rootScope.activeHttpRequests=0;
          
          if( !config.noIndicator )
             $rootScope.activeHttpRequests++;
          
          var exclusiveRequest = (config.method == 'PUT' || config.method == 'POST' || config.method == 'PATCH' || config.method == 'DELETE' )
             && !config.suppressExclusiveRequest;
          exclusiveRequest = exclusiveRequest || config.forceExclusiveRequest;
          if( exclusiveRequest )
          {
             $rootScope.exclusiveRequestPending = true;
             config.exclusiveRequest = true;
          }
          
          var $location = $injector.get('$location');
          var url = $location.url();
          if(url && url != '/login' && !url.indexOf('/login?') == 0)
             config.headers['X-LogBook-Location'] = $location.absUrl();
          return config;
        },
        'response': function(response) {
           if( !response.config.noExtendSession && !response.config.cache )
              logoutService.extendSession();
           if( response.config.exclusiveRequest )
              $rootScope.exclusiveRequestPending = false;
          if( !response.config.noIndicator )
             $rootScope.activeHttpRequests--;
          if ($rootScope.authenticated)
            $rootScope.lastAuthenticatedRequest = new Date().getTime();

			const headerApiVersion = response.headers('X-LogBook-Api-Version');
			if (headerApiVersion)
            {
                logBookService.LOGBOOK_API_VERSION = headerApiVersion;
            }
			
          $httpProvider.checkForUserMismatch($rootScope, $window, response);
          
          var userModified = response.headers('X-Logbook-User-Last-Modified');
          if( userModified )
          {
             userModified = parseInt(userModified);
             if( $rootScope.userLastModified && $rootScope.userLastModified < userModified )
                $rootScope.authenticate();
             
             $rootScope.userLastModified = userModified;
		  }
		  
		  if (['PUT', 'POST', 'PATCH', 'DELETE'].includes(response.config.method) &&
		  	 response.config.url != 'api/loggedErrors') {
		  	 const $location = $injector.get('$location');
			  
			 if (!['/login', '/signup', '/markdown', '/report-editor'].includes($location.path())) {
			    const $route = $injector.get('$route');

				primeNGHelpersService.ajsSuccessfulSaveToast($location.search().tab, $route.current.$$route.title);
			 }
		  }
			
		  $httpProvider.cleanHrefs(response);
		  
          return response;
        },
        'responseError': function(rejection) {
          console.log(rejection);
          if( rejection.config.exclusiveRequest )
             $rootScope.exclusiveRequestPending = false;
          if( !rejection.config.noIndicator )
             $rootScope.activeHttpRequests--;
          // Don't know why we have to do this, but rejection.data
          // wants to come through as a string on the 401 error.
          if (typeof(rejection.data) != 'Object')
            try {
              rejection.data = JSON.parse(rejection.data);
            } catch (err) {}
          if( $httpProvider.checkForUserMismatch($rootScope, $window, rejection) )
             return $q.reject('user mismatch');
          
          var cause = rejection.data;
          for( var i=0; i<20 && cause && cause.cause; i++ )
             cause = cause.cause;
          var isApi = rejection.config && rejection.config.url && rejection.config.url.indexOf('/api/') == 0;

          var errorMessage='';
          if(cause && cause.message)
             errorMessage = cause.message;
          else if( rejection.data && rejection.data.errors && rejection.data.errors.length )
          {
             if( rejection.config.rawError )
                errorMessage = rejection.data.errors;
             else
                for( var i=0, error; error = rejection.data.errors[i]; i++ )
                {
                   if( i>0 ) errorMessage += '. ';
                   if( error.invalidValue && error.message && !rejection.config.noValue)
                   {
                      var value = error.invalidValue.length > 255
                         ? error.invalidValue.substring(0,255) + "..."
                         : error.invalidValue;
                      errorMessage += 'Invalid value "'+value+'"; '+error.message;
                   }
                   else
                      errorMessage += error.message;
                }

             }
          if( errorMessage == '')
             errorMessage = rejection.statusText;

          if (rejection.status == 0 || rejection.status == -1) {
            if (!$rootScope.lastConnectionFailedMessage || new Date().getTime() - $rootScope.lastConnectionFailedMessage > 100) {

               var message = 'The attempt to contact the server failed.  Please check your internet ' 
                  + 'connection, or try again in a few minutes.';
               
			   rejection.errorMessage = message;
			   
			   if( !showErrorDialog() && !rejection.config.noErrorPopup && (!rejection.config.timeout || !rejection.config.timeout.suppressErrorFlag) )
			   	  primeNGHelpersService.showErrorToast(message, 'Connection Error');
			  
			   $rootScope.lastConnectionFailedMessage = new Date().getTime();
            }

          }
          if (rejection.data && rejection.data.status == 401) {
              $rootScope.$emit('$routeChangeError');
              $injector.get('authService').onUnauthenticated(rejection.data);
          } else if( rejection.data && rejection.data.status == 503 && rejection.data.maintenanceInfo ) {
              $injector.get('appStateService').updateMaintenanceMode(rejection.data);
          } else if (errorMessage) {
			 if( !rejection.config.noErrorPopup && !showErrorDialog() )
			 	 primeNGHelpersService.showErrorToast('An error occurred during the attempt to service your request:\n\n ' + errorMessage);
             else if( !rejection.config.batchRequest && !rejection.config.returnError )
                return $q.reject(errorMessage);
          }

          return $q.reject(rejection);
        }
      };
    }]);
  }])
  /*.config(function (SpringDataRestInterceptorProvider) {
    SpringDataRestInterceptorProvider.apply();
  })*/;
